module.exports = __webpack_public_path__ + "img/data-null.4944b64.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal_center/data-null.png
// module id = DtUH
// module chunks = 16